var _g, _g2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUdp(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 119.2 95.9",
    style: {
      enableBackground: "new 0 0 119.2 95.9"
    },
    xmlSpace: "preserve",
    fill: "white",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M43.6,33.9c1.7,0,3.2-1.4,3.2-3.2v-7.9c0-1.7-1.4-3.2-3.2-3.2c-1.7,0-3.2,1.4-3.2,3.2v7.9 C40.5,32.5,41.9,33.9,43.6,33.9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55,59.8c-1.7,0-3.2,1.4-3.2,3.2v6.7c0,1.7,1.4,3.2,3.2,3.2c1.7,0,3.2-1.4,3.2-3.2v-6.7 C58.1,61.2,56.7,59.8,55,59.8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77,40.6l-0.1-0.2c-1.2-2.1-3.3-3.2-6.1-3.2h-6.2c-1.5,0-2.8,1.1-3.1,2.5c0,0.2-0.1,0.4-0.1,0.6V55 c0,1.8,1.4,3.2,3.2,3.2s3.2-1.4,3.2-3.2v-3h2.8c3,0,5.2-1.1,6.4-3.2l0.1-0.2c0.6-1.1,0.9-2.4,0.9-4l0,0 C77.8,43.1,77.6,41.8,77,40.6z M71.4,44.7c0,1.1-0.4,1.4-1.4,1.4h-2.3v-2.9h2.1C71.2,43.3,71.4,43.6,71.4,44.7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.4,37.1l-4.9,0c-1.8,0-3.2,1.4-3.2,3.2v14.8c0,1.8,1.4,3.2,3.2,3.2l3.9,0c2.6,0,5.1-0.1,7.3-1.9 c2.3-1.8,3.5-4.8,3.5-8.6C58.1,40.8,54.8,37.1,48.4,37.1z M51.6,47.8c0,1.7-0.3,3-0.9,3.7c-0.6,0.7-1.5,1-2.9,1h-1.2V43h1.7 C50.3,43,51.6,43.8,51.6,47.8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.2,36.9c-1,0-1.8,0.3-2.3,0.9c-0.5,0.6-0.8,1.3-0.8,2.4v10c0,2.3-0.7,2.7-2.2,2.7c-1.5,0-2.2-0.4-2.2-2.7 v-9.8c0-0.1,0-0.2,0-0.3c0-0.2,0-0.3,0-0.5l0-0.2c0-0.1,0-0.1-0.1-0.2c-0.3-0.9-1-1.6-1.8-1.9c-0.3-0.1-0.7-0.2-1-0.2H17 c-1.6,0-3,1.3-3,3s1.3,3,3,3h2.4v7.5c0,5.1,3.2,8.1,8.5,8.1c2.6,0,4.7-0.7,6.2-2.1c1.5-1.4,2.3-3.4,2.3-6V40.1 C36.3,38.1,35.1,36.9,33.2,36.9z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M46.5,6.5c22,0,40,17.9,40,40s-17.9,40-40,40s-40-17.9-40-40S24.5,6.5,46.5,6.5 M46.5,0C20.8,0,0,20.8,0,46.5 S20.8,93,46.5,93S93,72.2,93,46.5S72.2,0,46.5,0L46.5,0z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUdp);
export default __webpack_public_path__ + "static/media/udp.1b802e79.svg";
export { ForwardRef as ReactComponent };